import { Component, OnInit } from '@angular/core';
import { AppEnum } from 'src/app/appenum';
import { AppService } from 'src/app/services/app.service';
import { EncryptionService } from 'src/app/services/encryption.service';

@Component({
  selector: 'app-language-toggle',
  templateUrl: './language-toggle.component.html',
  styleUrls: ['./language-toggle.component.scss'],
  standalone: false
})
export class LanguageToggleComponent implements OnInit {
  isMultipleLanguage: boolean = false;

  constructor(public _appservice: AppService,
    private encryptionService: EncryptionService,
    private _appenum: AppEnum
  ) { }

  ngOnInit() {
    const languageArr = JSON.parse(this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.languageData)));
    this.isMultipleLanguage = languageArr?.length > 1;
  }

}
